"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniquePlugins = exports.getResolveConfig = exports.transformConfig = exports.getMergedConfig = exports.mergeExtends = exports.prefixRules = exports.transformApiDefinitionsToApis = exports.parsePresetName = void 0;
const colorette_1 = require("colorette");
const utils_1 = require("../utils");
const config_1 = require("./config");
function parsePresetName(presetName) {
    if (presetName.indexOf('/') > -1) {
        const [pluginId, configName] = presetName.split('/');
        return { pluginId, configName };
    }
    else {
        return { pluginId: '', configName: presetName };
    }
}
exports.parsePresetName = parsePresetName;
function transformApiDefinitionsToApis(apiDefinitions) {
    if (!apiDefinitions)
        return undefined;
    const apis = {};
    for (const [apiName, apiPath] of Object.entries(apiDefinitions)) {
        apis[apiName] = { root: apiPath };
    }
    return apis;
}
exports.transformApiDefinitionsToApis = transformApiDefinitionsToApis;
function transformApis(legacyApis) {
    if (!legacyApis)
        return undefined;
    const apis = {};
    for (let _a of Object.entries(legacyApis)) {
        const [apiName, _b] = _a, { lint } = _b, apiContent = __rest(_b, ["lint"]);
        apis[apiName] = Object.assign({ styleguide: lint }, apiContent);
    }
    return apis;
}
function prefixRules(rules, prefix) {
    if (!prefix)
        return rules;
    const res = {};
    for (const name of Object.keys(rules)) {
        res[`${prefix}/${name}`] = rules[name];
    }
    return res;
}
exports.prefixRules = prefixRules;
function mergeExtends(rulesConfList) {
    const result = {
        rules: {},
        oas2Rules: {},
        oas3_0Rules: {},
        oas3_1Rules: {},
        preprocessors: {},
        oas2Preprocessors: {},
        oas3_0Preprocessors: {},
        oas3_1Preprocessors: {},
        decorators: {},
        oas2Decorators: {},
        oas3_0Decorators: {},
        oas3_1Decorators: {},
        plugins: [],
        pluginPaths: [],
        extendPaths: [],
    };
    for (let rulesConf of rulesConfList) {
        if (rulesConf.extends) {
            throw new Error(`'extends' is not supported in shared configs yet: ${JSON.stringify(rulesConf, null, 2)}.`);
        }
        Object.assign(result.rules, rulesConf.rules);
        Object.assign(result.oas2Rules, rulesConf.oas2Rules);
        utils_1.assignExisting(result.oas2Rules, rulesConf.rules || {});
        Object.assign(result.oas3_0Rules, rulesConf.oas3_0Rules);
        utils_1.assignExisting(result.oas3_0Rules, rulesConf.rules || {});
        Object.assign(result.oas3_1Rules, rulesConf.oas3_1Rules);
        utils_1.assignExisting(result.oas3_1Rules, rulesConf.rules || {});
        Object.assign(result.preprocessors, rulesConf.preprocessors);
        Object.assign(result.oas2Preprocessors, rulesConf.oas2Preprocessors);
        utils_1.assignExisting(result.oas2Preprocessors, rulesConf.preprocessors || {});
        Object.assign(result.oas3_0Preprocessors, rulesConf.oas3_0Preprocessors);
        utils_1.assignExisting(result.oas3_0Preprocessors, rulesConf.preprocessors || {});
        Object.assign(result.oas3_1Preprocessors, rulesConf.oas3_1Preprocessors);
        utils_1.assignExisting(result.oas3_1Preprocessors, rulesConf.preprocessors || {});
        Object.assign(result.decorators, rulesConf.decorators);
        Object.assign(result.oas2Decorators, rulesConf.oas2Decorators);
        utils_1.assignExisting(result.oas2Decorators, rulesConf.decorators || {});
        Object.assign(result.oas3_0Decorators, rulesConf.oas3_0Decorators);
        utils_1.assignExisting(result.oas3_0Decorators, rulesConf.decorators || {});
        Object.assign(result.oas3_1Decorators, rulesConf.oas3_1Decorators);
        utils_1.assignExisting(result.oas3_1Decorators, rulesConf.decorators || {});
        result.plugins.push(...(rulesConf.plugins || []));
        result.pluginPaths.push(...(rulesConf.pluginPaths || []));
        result.extendPaths.push(...new Set(rulesConf.extendPaths));
    }
    return result;
}
exports.mergeExtends = mergeExtends;
function getMergedConfig(config, apiName) {
    var _a, _b, _c, _d, _e, _f;
    const extendPaths = [
        ...Object.values(config.apis).map((api) => { var _a; return (_a = api === null || api === void 0 ? void 0 : api.styleguide) === null || _a === void 0 ? void 0 : _a.extendPaths; }),
        (_b = (_a = config.rawConfig) === null || _a === void 0 ? void 0 : _a.styleguide) === null || _b === void 0 ? void 0 : _b.extendPaths,
    ]
        .flat()
        .filter(Boolean);
    const pluginPaths = [
        ...Object.values(config.apis).map((api) => { var _a; return (_a = api === null || api === void 0 ? void 0 : api.styleguide) === null || _a === void 0 ? void 0 : _a.pluginPaths; }),
        (_d = (_c = config.rawConfig) === null || _c === void 0 ? void 0 : _c.styleguide) === null || _d === void 0 ? void 0 : _d.pluginPaths,
    ]
        .flat()
        .filter(Boolean);
    return apiName
        ? new config_1.Config(Object.assign(Object.assign({}, config.rawConfig), { styleguide: Object.assign(Object.assign({}, (config.apis[apiName]
                ? config.apis[apiName].styleguide
                : config.rawConfig.styleguide)), { extendPaths,
                pluginPaths }), 'features.openapi': Object.assign(Object.assign({}, config['features.openapi']), (_e = config.apis[apiName]) === null || _e === void 0 ? void 0 : _e['features.openapi']), 'features.mockServer': Object.assign(Object.assign({}, config['features.mockServer']), (_f = config.apis[apiName]) === null || _f === void 0 ? void 0 : _f['features.mockServer']) }), config.configFile)
        : config;
}
exports.getMergedConfig = getMergedConfig;
function checkForDeprecatedFields(deprecatedField, updatedField, rawConfig) {
    const isDeprecatedFieldInApis = rawConfig.apis &&
        Object.values(rawConfig.apis).some((api) => api[deprecatedField]);
    if (rawConfig[deprecatedField] && rawConfig[updatedField]) {
        throw new Error(`Do not use '${deprecatedField}' field. Use '${updatedField}' instead.\n`);
    }
    if (rawConfig[deprecatedField] || isDeprecatedFieldInApis) {
        process.stderr.write(`The ${colorette_1.yellow(deprecatedField)} field is deprecated. Use ${colorette_1.green(updatedField)} instead. Read more about this change: https://redocly.com/docs/api-registry/guides/migration-guide-config-file/#changed-properties\n`);
    }
}
function transformConfig(rawConfig) {
    const migratedFields = [
        ['apiDefinitions', 'apis'],
        ['referenceDocs', 'features.openapi'],
        ['lint', 'styleguide'], // TODO: update docs
    ];
    for (const [deprecatedField, updatedField] of migratedFields) {
        checkForDeprecatedFields(deprecatedField, updatedField, rawConfig);
    }
    const { apis, apiDefinitions, referenceDocs, lint } = rawConfig, rest = __rest(rawConfig, ["apis", "apiDefinitions", "referenceDocs", "lint"]);
    return Object.assign({ 'features.openapi': referenceDocs, apis: transformApis(apis) || transformApiDefinitionsToApis(apiDefinitions), styleguide: lint }, rest);
}
exports.transformConfig = transformConfig;
function getResolveConfig(resolve) {
    var _a, _b;
    return {
        http: {
            headers: (_b = (_a = resolve === null || resolve === void 0 ? void 0 : resolve.http) === null || _a === void 0 ? void 0 : _a.headers) !== null && _b !== void 0 ? _b : [],
            customFetch: undefined,
        },
    };
}
exports.getResolveConfig = getResolveConfig;
function getUniquePlugins(plugins) {
    const seen = new Set();
    const results = [];
    for (const p of plugins) {
        if (!seen.has(p.id)) {
            results.push(p);
            seen.add(p.id);
        }
        else if (p.id) {
            process.stderr.write(`Duplicate plugin id "${colorette_1.yellow(p.id)}".\n`);
        }
    }
    return results;
}
exports.getUniquePlugins = getUniquePlugins;
